export const regions = [
    {
    text: 'Все',
    value: '0'
}, {
    text: 'Москва',
    value: '77_170'
}, {
    text: 'Санкт-Петербург',
    value: '78_171'
}, {
    text: 'Севастополь',
    value: '92_178'
}, {
    text: 'Алтайский край',
    value: '22_115'
}, {
    text: 'Амурская область',
    value: '28_121'
}, {
    text: 'Архангельская область',
    value: '29_122'
}, {
    text: 'Астраханская область',
    value: '30_123'
}, {
    text: 'Белгородская область',
    value: '31_124'
}, {
    text: 'Брянская область',
    value: '32_125'
}, {
    text: 'Владимирская область',
    value: '33_126'
}, {
    text: 'Волгоградская область',
    value: '34_127'
}, {
    text: 'Вологодская область',
    value: '35_128'
}, {
    text: 'Воронежская область',
    value: '36_129'
}, {
    text: 'Еврейская автономная область',
    value: '79_172'
}, {
    text: 'Забайкальский край',
    value: '75_168'
}, {
    text: 'Ивановская область',
    value: '37_130'
}, {
    text: 'Иркутская область',
    value: '38_131'
}, {
    text: 'Кабардино-Балкарская Республика',
    value: '07_100'
}, {
    text: 'Калининградская область',
    value: '39_132'
}, {
    text: 'Калужская область',
    value: '40_133'
}, {
    text: 'Камчатский край',
    value: '41_134'
}, {
    text: 'Карачаево-Черкесская Республика',
    value: '09_102'
}, {
    text: 'Кемеровская область',
    value: '42_135'
}, {
    text: 'Кировская область',
    value: '43_136'
}, {
    text: 'Костромская область',
    value: '44_137'
}, {
    text: 'Краснодарский край',
    value: '23_116'
}, {
    text: 'Красноярский край',
    value: '24_117'
}, {
    text: 'Курганская область',
    value: '45_138'
}, {
    text: 'Курская область',
    value: '46_139'
}, {
    text: 'Ленинградская область',
    value: '47_140'
}, {
    text: 'Липецкая область',
    value: '48_141'
}, {
    text: 'Магаданская область',
    value: '49_142'
}, {
    text: 'Московская область',
    value: '50_143'
}, {
    text: 'Мурманская область',
    value: '51_144'
}, {
    text: 'Ненецкий автономный округ',
    value: '83_173'
}, {
    text: 'Нижегородская область',
    value: '52_145'
}, {
    text: 'Новгородская область',
    value: '53_146'
}, {
    text: 'Новосибирская область',
    value: '54_147'
}, {
    text: 'Омская область',
    value: '55_148'
}, {
    text: 'Оренбургская область',
    value: '56_149'
}, {
    text: 'Орловская область',
    value: '57_150'
}, {
    text: 'Пензенская область',
    value: '58_151'
}, {
    text: 'Пермский край',
    value: '59_152'
}, {
    text: 'Приморский край',
    value: '25_118'
}, {
    text: 'Псковская область',
    value: '60_153'
}, {
    text: 'Республика Адыгея',
    value: '01_94'
}, {
    text: 'Республика Алтай',
    value: '04_97'
}, {
    text: 'Республика Башкортостан',
    value: '02_95'
}, {
    text: 'Республика Бурятия',
    value: '03_96'
}, {
    text: 'Республика Дагестан',
    value: '05_98'
}, {
    text: 'Республика Ингушетия',
    value: '06_99'
}, {
    text: 'Республика Калмыкия',
    value: '08_101'
}, {
    text: 'Республика Карелия',
    value: '10_103'
}, {
    text: 'Республика Коми',
    value: '11_104'
}, {
    text: 'Республика Крым',
    value: '91_177'
}, {
    text: 'Республика Марий Эл',
    value: '12_105'
}, {
    text: 'Республика Мордовия',
    value: '13_106'
}, {
    text: 'Республика Саха (Якутия)',
    value: '14_107'
}, {
    text: 'Республика Северная Осетия - Алания',
    value: '15_108'
}, {
    text: 'Республика Татарстан',
    value: '16_109'
}, {
    text: 'Республика Тыва',
    value: '17_110'
}, {
    text: 'Республика Хакасия',
    value: '19_112'
}, {
    text: 'Ростовская область',
    value: '61_154'
}, {
    text: 'Рязанская область',
    value: '62_155'
}, {
    text: 'Самарская область',
    value: '63_156'
}, {
    text: 'Саратовская область',
    value: '64_157'
}, {
    text: 'Сахалинская область',
    value: '65_158'
}, {
    text: 'Свердловская область',
    value: '66_159'
}, {
    text: 'Смоленская область',
    value: '67_160'
}, {
    text: 'Ставропольский край',
    value: '26_119'
}, {
    text: 'Тамбовская область',
    value: '68_161'
}, {
    text: 'Тверская область',
    value: '69_162'
}, {
    text: 'Томская область',
    value: '70_163'
}, {
    text: 'Тульская область',
    value: '71_164'
}, {
    text: 'Тюменская область',
    value: '72_165'
}, {
    text: 'Удмуртская Республика',
    value: '18_111'
}, {
    text: 'Ульяновская область',
    value: '73_166'
}, {
    text: 'Хабаровский край',
    value: '27_120'
}, {
    text: 'Ханты-Мансийский автономный округ - Югра',
    value: '86_174'
}, {
    text: 'Челябинская область',
    value: '74_167'
}, {
    text: 'Чеченская Республика',
    value: '20_113'
}, {
    text: 'Чувашская Республика',
    value: '21_114'
}, {
    text: 'Чукотский автономный округ',
    value: '87_175'
}, {
    text: 'Ямало-Ненецкий автономный округ',
    value: '89_176'
}, {
    text: 'Ярославская область',
    value: '76_169'
}];

export const cities = [{ value: '73_19', regionId: '19', text: 'Абакан' },
    { value: '2093_56', regionId: '56', text: 'Абдулино' },
    { value: '430_16', regionId: '16', text: 'Агрыз' },
    { value: '239_23', regionId: '23', text: 'Адлер' },
    { value: '99_16', regionId: '16', text: 'Азнакаево' },
    { value: '434_61', regionId: '61', text: 'Азов' },
    { value: '309_61', regionId: '61', text: 'Аксай' },
    { value: '457_21', regionId: '21', text: 'Алатырь' },
    { value: '100_14', regionId: '14', text: 'Алдан' },
    { value: '187_33', regionId: '33', text: 'Александров' },
    { value: '229_31', regionId: '31', text: 'Алексеевка' },
    { value: '101_16', regionId: '16', text: 'Альметьевск' },
    { value: '211_23', regionId: '23', text: 'Анапа' },
    { value: '348_38', regionId: '38', text: 'Ангарск' },
    { value: '102_16', regionId: '16', text: 'Апастово' },
    { value: '1944_66', regionId: '66', text: 'Арамиль' },
    { value: '415_52', regionId: '52', text: 'Арзамас' },
    { value: '103_16', regionId: '16', text: 'Арск' },
    { value: '2116_25', regionId: '25', text: 'Артем' },
    { value: '9_29', regionId: '29', text: 'Архангельск' },
    { value: '1945_66', regionId: '66', text: 'Асбест' },
    { value: '8_30', regionId: '30', text: 'Астрахань' },
    { value: '266_30', regionId: '30', text: 'Ахтубинск' },
    { value: '259_24', regionId: '24', text: 'Ачинск' },
    { value: '279_74', regionId: '74', text: 'Аша' },
    { value: '104_16', regionId: '16', text: 'Бавлы' },
    { value: '443_61', regionId: '61', text: 'Багаевская' },
    { value: '2147_7', regionId: '7', text: 'Баксан' },
    { value: '1962_40', regionId: '40', text: 'Балабаново' },
    { value: '105_64', regionId: '64', text: 'Балаково' },
    { value: '418_52', regionId: '52', text: 'Балахна' },
    { value: '1990_39', regionId: '39', text: 'Балтийск' },
    { value: '63_22', regionId: '22', text: 'Барнаул' },
    { value: '218_61', regionId: '61', text: 'Батайск' },
    { value: '231_69', regionId: '69', text: 'Бежецк' },
    { value: '449_63', regionId: '63', text: 'Безенчук' },
    { value: '18_31', regionId: '31', text: 'Белгород' },
    { value: '2037_2', regionId: '2', text: 'Белебей' },
    { value: '270_58', regionId: '58', text: 'Белинский' },
    { value: '352_42', regionId: '42', text: 'Белово' },
    { value: '323_22', regionId: '22', text: 'Белокуриха' },
    { value: '286_2', regionId: '2', text: 'Белорецк' },
    { value: '2008_54', regionId: '54', text: 'Бердск' },
    { value: '106_59', regionId: '59', text: 'Березники' },
    { value: '354_42', regionId: '42', text: 'Березовский' },
    { value: '1946_66', regionId: '66', text: 'Березовский' },
    { value: '107_22', regionId: '22', text: 'Бийск' },
    { value: '76_79', regionId: '79', text: 'Биробиджан' },
    { value: '75_28', regionId: '28', text: 'Благовещенск' },
    { value: '468_2', regionId: '2', text: 'Благовещенск' },
    { value: '479_52', regionId: '52', text: 'Богородск' },
    { value: '2032_52', regionId: '52', text: 'Бор' },
    { value: '1972_36', regionId: '36', text: 'Борисоглебск' },
    { value: '147_38', regionId: '38', text: 'Братск' },
    { value: '384_50', regionId: '50', text: 'Бронницы' },
    { value: '19_32', regionId: '32', text: 'Брянск' },
    { value: '109_16', regionId: '16', text: 'Бугульма' },
    { value: '2094_56', regionId: '56', text: 'Бугуруслан' },
    { value: '284_56', regionId: '56', text: 'Бузулук' },
    { value: '110_16', regionId: '16', text: 'Буинск' },
    { value: '1920_47', regionId: '47', text: 'в/г Агалатово' },
    { value: '335_31', regionId: '31', text: 'Валуйки' },
    { value: '2157_60', regionId: '60', text: 'Великие Луки' },
    { value: '14_53', regionId: '53', text: 'Великий Новгород' },
    { value: '201_35', regionId: '35', text: 'Великий Устюг' },
    { value: '210_71', regionId: '71', text: 'Венёв' },
    { value: '1947_66', regionId: '66', text: 'Верхняя Пышма' },
    { value: '2238_66', regionId: '66', text: 'Верхняя Салда' },
    { value: '232_69', regionId: '69', text: 'Весьегонск' },
    { value: '321_50', regionId: '50', text: 'Видное' },
    { value: '2289_47', regionId: '47', text: 'Виллозское с.п.' },
    { value: '254_14', regionId: '14', text: 'Витим пос.' },
    { value: '78_25', regionId: '25', text: 'Владивосток' },
    { value: '38_15', regionId: '15', text: 'Владикавказ' },
    { value: '20_33', regionId: '33', text: 'Владимир' },
    { value: '33_34', regionId: '34', text: 'Волгоград' },
    { value: '310_61', regionId: '61', text: 'Волгодонск' },
    { value: '2151_12', regionId: '12', text: 'Волжск' },
    { value: '34_34', regionId: '34', text: 'Волжский' },
    { value: '2002_63', regionId: '63', text: 'Волжский' },
    { value: '10_35', regionId: '35', text: 'Вологда' },
    { value: '417_52', regionId: '52', text: 'Володарск' },
    { value: '402_50', regionId: '50', text: 'Волоколамск' },
    { value: '161_47', regionId: '47', text: 'Волхов' },
    { value: '322_11', regionId: '11', text: 'Воркута' },
    { value: '21_36', regionId: '36', text: 'Воронеж' },
    { value: '397_50', regionId: '50', text: 'Воскресенск' },
    { value: '452_18', regionId: '18', text: 'Воткинск' },
    { value: '160_47', regionId: '47', text: 'Всеволожск' },
    { value: '159_47', regionId: '47', text: 'Выборг' },
    { value: '243_52', regionId: '52', text: 'Выкса' },
    { value: '249_69', regionId: '69', text: 'Вышний Волочек' },
    { value: '472_33', regionId: '33', text: 'Вязники' },
    { value: '2081_67', regionId: '67', text: 'Вязьма' },
    { value: '2394_25', regionId: '25', text: 'г. Большой Камень' },
    { value: '2001_64', regionId: '64', text: 'г.Балашов' },
    { value: '2166_57', regionId: '57', text: 'г.Бузулук' },
    { value: '1816_50', regionId: '50', text: 'г.Высоковск' },
    { value: '1813_50', regionId: '50', text: 'г.Дедовск' },
    { value: '1812_50', regionId: '50', text: 'г.Дрезна' },
    { value: '1814_50', regionId: '50', text: 'г.Кашира' },
    { value: '1911_47', regionId: '47', text: 'г.Коммунар' },
    { value: '1852_50', regionId: '50', text: 'г.о. Балашиха' },
    { value: '1896_47', regionId: '47', text: 'г.п. Кузьмоловский' },
    { value: '2249_47', regionId: '47', text: 'г.п.Дубровка' },
    { value: '2292_47', regionId: '47', text: 'г.п.им.Свердлова' },
    { value: '2343_50', regionId: '50', text: 'г.п.Поварово' },
    { value: '2288_47', regionId: '47', text: 'г.п.Рахья' },
    { value: '2287_47', regionId: '47', text: 'г.п.Токсово' },
    { value: '2348_50', regionId: '50', text: 'г.п.Удельная' },
    { value: '1809_50', regionId: '50', text: 'г.Протвино' },
    { value: '2056_61', regionId: '61', text: 'г.Цимлянск' },
    { value: '2082_67', regionId: '67', text: 'Гагарин' },
    { value: '2095_56', regionId: '56', text: 'Гай' },
    { value: '2019_59', regionId: '59', text: 'Гамово' },
    { value: '317_47', regionId: '47', text: 'Гатчина' },
    { value: '1991_39', regionId: '39', text: 'Гвардейск' },
    { value: '1974_23', regionId: '23', text: 'Геленджик' },
    { value: '455_18', regionId: '18', text: 'Глазов' },
    { value: '2373_50', regionId: '50', text: 'Голицыно' },
    { value: '404_50', regionId: '50', text: 'Горки-2' },
    { value: '70_4', regionId: '4', text: 'Горно-Алтайск' },
    { value: '481_52', regionId: '52', text: 'Городец' },
    { value: '272_58', regionId: '58', text: 'Городище' },
    { value: '212_23', regionId: '23', text: 'Горячий ключ' },
    { value: '42_20', regionId: '20', text: 'Грозный' },
    { value: '2062_31', regionId: '31', text: 'Губкин' },
    { value: '439_61', regionId: '61', text: 'Гуково' },
    { value: '1980_42', regionId: '42', text: 'Гурьевск' },
    { value: '1992_39', regionId: '39', text: 'Гурьевск' },
    { value: '340_33', regionId: '33', text: 'Гусь-Хрустальный' },
    { value: '2103_35', regionId: '35', text: 'д. Маурино' },
    { value: '2159_60', regionId: '60', text: 'д. Писковичи' },
    { value: '2158_60', regionId: '60', text: 'д. Родина' },
    { value: '2282_47', regionId: '47', text: 'д.Агалатово' },
    { value: '2332_50', regionId: '50', text: 'д.Александровка' },
    { value: '2108_35', regionId: '35', text: 'д.Алексино' },
    { value: '2266_67', regionId: '67', text: 'д.Алтуховка' },
    { value: '2189_52', regionId: '52', text: 'д.Анкудиновка' },
    { value: '2034_52', regionId: '52', text: 'д.Афонино' },
    { value: '2372_50', regionId: '50', text: 'д.Бережки' },
    { value: '2191_52', regionId: '52', text: 'д.Березовка' },
    { value: '2306_50', regionId: '50', text: 'д.Боброво' },
    { value: '2299_50', regionId: '50', text: 'д.Болдино' },
    { value: '1844_50', regionId: '50', text: 'д.Большие Жеребцы' },
    { value: '2243_60', regionId: '60', text: 'д.Борисовичи' },
    { value: '2204_53', regionId: '53', text: 'д.Борки' },
    { value: '2320_50', regionId: '50', text: 'д.Брехово' },
    { value: '2355_50', regionId: '50', text: 'д.Бузланово' },
    { value: '2368_50', regionId: '50', text: 'д.Бутово' },
    { value: '1924_47', regionId: '47', text: 'д.Вартемяги' },
    { value: '2310_50', regionId: '50', text: 'д.Ворщиково' },
    { value: '2304_50', regionId: '50', text: 'д.Высоково' },
    { value: '2172_33', regionId: '33', text: 'д.Вяткино' },
    { value: '2311_50', regionId: '50', text: 'д.Голубое' },
    { value: '1916_47', regionId: '47', text: 'д.Горбунки' },
    { value: '2341_50', regionId: '50', text: 'д.Гребнево' },
    { value: '2229_76', regionId: '76', text: 'д.Губцево' },
    { value: '2367_50', regionId: '50', text: 'д.Давыдовское' },
    { value: '2179_37', regionId: '37', text: 'д.Дерябиха' },
    { value: '2312_50', regionId: '50', text: 'д.Десна' },
    { value: '2305_50', regionId: '50', text: 'д.Дрожжино' },
    { value: '2315_50', regionId: '50', text: 'д.Ермолино' },
    { value: '2091_76', regionId: '76', text: 'д.Ермолово ' },
    { value: '2165_57', regionId: '57', text: 'д.Жилина' },
    { value: '2347_50', regionId: '50', text: 'д.Зверево' },
    { value: '2365_50', regionId: '50', text: 'д.Ивакино' },
    { value: '2346_50', regionId: '50', text: 'д.Ивановское' },
    { value: '2388_50', regionId: '50', text: 'д.Исаково' },
    { value: '2187_40', regionId: '40', text: 'д.Кабицыно' },
    { value: '2119_74', regionId: '74', text: 'д.Казанцево' },
    { value: '1909_47', regionId: '47', text: 'д.Кипень' },
    { value: '2213_70', regionId: '70', text: 'д.Кисловка' },
    { value: '2323_50', regionId: '50', text: 'д.Козино' },
    { value: '1910_47', regionId: '47', text: 'д.Колтуши' },
    { value: '2020_59', regionId: '59', text: 'д.Кондратово' },
    { value: '2083_68', regionId: '68', text: 'д.Красненькая' },
    { value: '2340_50', regionId: '50', text: 'д.Красный поселок' },
    { value: '1897_47', regionId: '47', text: 'д.Кудрово' },
    { value: '2092_76', regionId: '76', text: 'д.Кузнечиха' },
    { value: '2036_52', regionId: '52', text: 'д.Кусаковка' },
    { value: '2206_16', regionId: '16', text: 'д.Куюки' },
    { value: '1898_47', regionId: '47', text: 'д.Лаврики' },
    { value: '2276_47', regionId: '47', text: 'д.Лесколово' },
    { value: '2336_50', regionId: '50', text: 'д.Ликова' },
    { value: '2230_76', regionId: '76', text: 'д.Липовицы' },
    { value: '2188_40', regionId: '40', text: 'д.Литвиново' },
    { value: '2319_50', regionId: '50', text: 'д.Лобаново' },
    { value: '2308_50', regionId: '50', text: 'д.Лопатино' },
    { value: '2335_50', regionId: '50', text: 'д.Лопотово' },
    { value: '2279_47', regionId: '47', text: 'д.Лупполово' },
    { value: '2211_59', regionId: '59', text: 'д.Малая' },
    { value: '2251_71', regionId: '71', text: 'д.Малевка' },
    { value: '2313_50', regionId: '50', text: 'д.Малые Вяземы' },
    { value: '2318_50', regionId: '50', text: 'д.Мартемьяново' },
    { value: '2307_50', regionId: '50', text: 'д.Марусино' },
    { value: '2107_35', regionId: '35', text: 'д.Марфино' },
    { value: '2342_50', regionId: '50', text: 'д.Марьино' },
    { value: '2381_50', regionId: '50', text: 'д.Мисайлово' },
    { value: '2366_50', regionId: '50', text: 'д.Митькино' },
    { value: '2300_50', regionId: '50', text: 'д.Мотяково' },
    { value: '1914_47', regionId: '47', text: 'д.Низино' },
    { value: '2351_50', regionId: '50', text: 'д.Николо-Хованское' },
    { value: '2354_50', regionId: '50', text: 'д.Оболдино' },
    { value: '2254_57', regionId: '57', text: 'д.Образцово' },
    { value: '2357_50', regionId: '50', text: 'д.п.Родники' },
    { value: '2361_50', regionId: '50', text: 'д.Павшино' },
    { value: '2210_59', regionId: '59', text: 'д.Паздерино' },
    { value: '2244_60', regionId: '60', text: 'д.Паклино' },
    { value: '2384_50', regionId: '50', text: 'д.Погорелки' },
    { value: '2302_50', regionId: '50', text: 'д.Подолино' },
    { value: '2231_76', regionId: '76', text: 'д.Полесье' },
    { value: '2270_47', regionId: '47', text: 'д.Порошкино' },
    { value: '1883_50', regionId: '50', text: 'д.Путилково' },
    { value: '2362_50', regionId: '50', text: 'д.Рассказовка' },
    { value: '2321_50', regionId: '50', text: 'д.Сабурово' },
    { value: '2296_50', regionId: '50', text: 'д.Солманово' },
    { value: '2269_47', regionId: '47', text: 'д.Старая' },
    { value: '2218_2', regionId: '2', text: 'д.Старые Киешки' },
    { value: '2322_50', regionId: '50', text: 'д.Столбово' },
    { value: '2216_42', regionId: '42', text: 'д.Сухово' },
    { value: '2356_50', regionId: '50', text: 'д.Тарычево' },
    { value: '2337_50', regionId: '50', text: 'д.Удино' },
    { value: '2286_47', regionId: '47', text: 'д.Узигонты' },
    { value: '1925_47', regionId: '47', text: 'д.Федоровское' },
    { value: '2256_18', regionId: '18', text: 'д.Хохряки' },
    { value: '2370_50', regionId: '50', text: 'д.Целеево' },
    { value: '2309_50', regionId: '50', text: 'д.Черная' },
    { value: '2382_50', regionId: '50', text: 'д.Шолохово' },
    { value: '2193_43', regionId: '43', text: 'д.Шутовщина' },
    { value: '2386_50', regionId: '50', text: 'д.Юрлово' },
    { value: '2272_47', regionId: '47', text: 'д.Янино-1' },
    { value: '2273_47', regionId: '47', text: 'д.Янино-2' },
    { value: '2239_66', regionId: '66', text: 'Дегтярск' },
    { value: '158_52', regionId: '52', text: 'Дзержинск' },
    { value: '377_50', regionId: '50', text: 'Дзержинский' },
    { value: '2009_54', regionId: '54', text: 'Дзержинский' },
    { value: '95_73', regionId: '73', text: 'Димитровград' },
    { value: '190_50', regionId: '50', text: 'Дмитров' },
    { value: '94_50', regionId: '50', text: 'Долгопрудный' },
    { value: '390_50', regionId: '50', text: 'Домодедово' },
    { value: '157_50', regionId: '50', text: 'Дубна' },
    { value: '2038_2', regionId: '2', text: 'Дюртюли' },
    { value: '2063_32', regionId: '32', text: 'Дятьково' },
    { value: '394_50', regionId: '50', text: 'Егорьевск' },
    { value: '213_23', regionId: '23', text: 'Ейск' },
    { value: '60_66', regionId: '66', text: 'Екатеринбург' },
    { value: '156_16', regionId: '16', text: 'Елабуга' },
    { value: '2134_26', regionId: '26', text: 'Ессентуки' },
    { value: '2135_26', regionId: '26', text: 'Железноводск' },
    { value: '2027_24', regionId: '24', text: 'Железногорск' },
    { value: '260_46', regionId: '46', text: 'Железногорск' },
    { value: '289_50', regionId: '50', text: 'Железнодорожный' },
    { value: '273_63', regionId: '63', text: 'Жигулевск' },
    { value: '299_34', regionId: '34', text: 'Жирновск' },
    { value: '2064_32', regionId: '32', text: 'Жуковка' },
    { value: '246_50', regionId: '50', text: 'Жуковский' },
    { value: '480_52', regionId: '52', text: 'Заволжье' },
    { value: '2079_48', regionId: '48', text: 'Задонск' },
    { value: '139_16', regionId: '16', text: 'Заинск' },
    { value: '391_50', regionId: '50', text: 'Зарайск' },
    { value: '48_58', regionId: '58', text: 'Заречный' },
    { value: '1951_66', regionId: '66', text: 'Заречный' },
    { value: '138_22', regionId: '22', text: 'Заринск' },
    { value: '191_50', regionId: '50', text: 'Звенигород' },
    { value: '440_61', regionId: '61', text: 'Зверево' },
    { value: '1894_78', regionId: '78', text: 'Зеленогорск' },
    { value: '189_77', regionId: '77', text: 'Зеленоград' },
    { value: '1993_39', regionId: '39', text: 'Зеленоградск' },
    { value: '471_16', regionId: '16', text: 'Зеленодольск' },
    { value: '277_74', regionId: '74', text: 'Златоуст' },
    { value: '334_30', regionId: '30', text: 'Знаменск' },
    { value: '360_46', regionId: '46', text: 'Золотухино' },
    { value: '87_37', regionId: '37', text: 'Иваново' },
    { value: '202_50', regionId: '50', text: 'Ивантеевка' },
    { value: '453_18', regionId: '18', text: 'Игра' },
    { value: '56_18', regionId: '18', text: 'Ижевск' },
    { value: '333_30', regionId: '30', text: 'Икряное' },
    { value: '413_50', regionId: '50', text: 'Икша' },
    { value: '65_38', regionId: '38', text: 'Иркутск' },
    { value: '181_50', regionId: '50', text: 'Истра' },
    { value: '2124_72', regionId: '72', text: 'Ишим' },
    { value: '2039_2', regionId: '2', text: 'Ишимбай' },
    { value: '51_12', regionId: '12', text: 'Йошкар-Ола' },
    { value: '438_61', regionId: '61', text: 'Кагальник' },
    { value: '53_16', regionId: '16', text: 'Казань' },
    { value: '12_39', regionId: '39', text: 'Калининград' },
    { value: '399_50', regionId: '50', text: 'Калининец' },
    { value: '22_40', regionId: '40', text: 'Калуга' },
    { value: '269_58', regionId: '58', text: 'Каменка' },
    { value: '155_66', regionId: '66', text: 'Каменск-Уральский' },
    { value: '154_22', regionId: '22', text: 'Камень-на-Оби' },
    { value: '332_30', regionId: '30', text: 'Камызяк' },
    { value: '196_34', regionId: '34', text: 'Камышин' },
    { value: '459_21', regionId: '21', text: 'Канаш' },
    { value: '2010_54', regionId: '54', text: 'Карасук' },
    { value: '2065_32', regionId: '32', text: 'Карачев' },
    { value: '238_62', regionId: '62', text: 'Касимов' },
    { value: '2144_5', regionId: '5', text: 'Каспийск' },
    { value: '225_50', regionId: '50', text: 'Кашира' },
    { value: '66_42', regionId: '42', text: 'Кемерово' },
    { value: '2130_45', regionId: '45', text: 'Кетово' },
    { value: '250_69', regionId: '69', text: 'Кимры' },
    { value: '153_47', regionId: '47', text: 'Кингисепп' },
    { value: '188_37', regionId: '37', text: 'Кинешма' },
    { value: '344_33', regionId: '33', text: 'Киржач' },
    { value: '319_47', regionId: '47', text: 'Кириши' },
    { value: '23_43', regionId: '43', text: 'Киров' },
    { value: '258_43', regionId: '43', text: 'Кирово-Чепецк' },
    { value: '1904_47', regionId: '47', text: 'Кировск' },
    { value: '1981_42', regionId: '42', text: 'Киселевск' },
    { value: '195_26', regionId: '26', text: 'Кисловодск' },
    { value: '367_50', regionId: '50', text: 'Климовск' },
    { value: '361_50', regionId: '50', text: 'Клин' },
    { value: '337_32', regionId: '32', text: 'Клинцы' },
    { value: '342_33', regionId: '33', text: 'Ковров' },
    { value: '311_72', regionId: '72', text: 'Когалым' },
    { value: '1937_86', regionId: '86', text: 'Когалым' },
    { value: '261_24', regionId: '24', text: 'Кодинск' },
    { value: '208_50', regionId: '50', text: 'Коломна' },
    { value: '1928_78', regionId: '78', text: 'Колпино' },
    { value: '341_33', regionId: '33', text: 'Кольчугино' },
    { value: '148_27', regionId: '27', text: 'Комсомольск-на-Амуре' },
    { value: '251_69', regionId: '69', text: 'Конаково' },
    { value: '349_40', regionId: '40', text: 'Кондрово' },
    { value: '379_50', regionId: '50', text: 'Константиново' },
    { value: '436_61', regionId: '61', text: 'Константиновск' },
    { value: '469_74', regionId: '74', text: 'Копейск' },
    { value: '409_50', regionId: '50', text: 'Королёв' },
    { value: '152_10', regionId: '10', text: 'Костомукша' },
    { value: '247_50', regionId: '50', text: 'Кострово' },
    { value: '151_44', regionId: '44', text: 'Кострома' },
    { value: '381_50', regionId: '50', text: 'Котельники' },
    { value: '84_29', regionId: '29', text: 'Котлас' },
    { value: '300_34', regionId: '34', text: 'Котово' },
    { value: '2084_68', regionId: '68', text: 'Котовск' },
    { value: '2077_37', regionId: '37', text: 'Кохма' },
    { value: '203_50', regionId: '50', text: 'Красноармейск' },
    { value: '150_50', regionId: '50', text: 'Красногорск' },
    { value: '35_23', regionId: '23', text: 'Краснодар' },
    { value: '1934_78', regionId: '78', text: 'Красное Село' },
    { value: '406_50', regionId: '50', text: 'Краснознаменск' },
    { value: '466_75', regionId: '75', text: 'Краснокаменск' },
    { value: '145_59', regionId: '59', text: 'Краснокамск' },
    { value: '2110_34', regionId: '34', text: 'Краснослободск' },
    { value: '164_66', regionId: '66', text: 'Краснотурьинск' },
    { value: '67_24', regionId: '24', text: 'Красноярск' },
    { value: '233_69', regionId: '69', text: 'Красный Холм' },
    { value: '421_57', regionId: '57', text: 'Кромы' },
    { value: '1853_50', regionId: '50', text: 'Крюково' },
    { value: '144_52', regionId: '52', text: 'Кстово' },
    { value: '400_50', regionId: '50', text: 'Кубинка' },
    { value: '143_59', regionId: '59', text: 'Кудымкар' },
    { value: '268_58', regionId: '58', text: 'Кузнецк' },
    { value: '427_2', regionId: '2', text: 'Кумертау' },
    { value: '141_59', regionId: '59', text: 'Кунгур' },
    { value: '59_45', regionId: '45', text: 'Курган' },
    { value: '345_33', regionId: '33', text: 'Курлово' },
    { value: '373_50', regionId: '50', text: 'Куровское' },
    { value: '24_46', regionId: '46', text: 'Курск' },
    { value: '2261_46', regionId: '46', text: 'Курчатов' },
    { value: '72_17', regionId: '17', text: 'Кызыл' },
    { value: '280_74', regionId: '74', text: 'Кыштым' },
    { value: '214_23', regionId: '23', text: 'Лабинск' },
    { value: '2160_89', regionId: '89', text: 'Лабытнанги' },
    { value: '403_50', regionId: '50', text: 'Лайково' },
    { value: '347_33', regionId: '33', text: 'Лакинск' },
    { value: '314_72', regionId: '72', text: 'Лангепас' },
    { value: '137_16', regionId: '16', text: 'Лениногорск' },
    { value: '475_42', regionId: '42', text: 'Ленинск-Кузнецкий' },
    { value: '135_14', regionId: '14', text: 'Ленск' },
    { value: '285_66', regionId: '66', text: 'Лесной' },
    { value: '136_24', regionId: '24', text: 'Лесосибирск' },
    { value: '419_57', regionId: '57', text: 'Ливны' },
    { value: '223_50', regionId: '50', text: 'Ликино–Дулево' },
    { value: '25_48', regionId: '48', text: 'Липецк' },
    { value: '1965_36', regionId: '36', text: 'Лиски' },
    { value: '288_50', regionId: '50', text: 'Лобня' },
    { value: '374_50', regionId: '50', text: 'Лосино-Петровский' },
    { value: '134_47', regionId: '47', text: 'Луга' },
    { value: '395_50', regionId: '50', text: 'Луховицы' },
    { value: '482_52', regionId: '52', text: 'Лысково' },
    { value: '385_50', regionId: '50', text: 'Лыткарино' },
    { value: '140_50', regionId: '50', text: 'Люберцы' },
    { value: '1938_86', regionId: '86', text: 'Лянтор' },
    { value: '77_49', regionId: '49', text: 'Магадан' },
    { value: '2146_6', regionId: '6', text: 'Магас' },
    { value: '93_74', regionId: '74', text: 'Магнитогорск' },
    { value: '37_1', regionId: '1', text: 'Майкоп' },
    { value: '197_7', regionId: '7', text: 'Майский' },
    { value: '382_50', regionId: '50', text: 'Малаховка' },
    { value: '291_40', regionId: '40', text: 'Малоярославец' },
    { value: '115_16', regionId: '16', text: 'Мамадыш' },
    { value: '256_42', regionId: '42', text: 'Мариинск' },
    { value: '40_5', regionId: '5', text: 'Махачкала' },
    { value: '1939_86', regionId: '86', text: 'Мегион' },
    { value: '476_72', regionId: '72', text: 'Мегион' },
    { value: '1982_42', regionId: '42', text: 'Междуреченск' },
    { value: '338_33', regionId: '33', text: 'Меленки' },
    { value: '429_2', regionId: '2', text: 'Мелеуз' },
    { value: '116_16', regionId: '16', text: 'Менделеевск' },
    { value: '117_16', regionId: '16', text: 'Мензелинск' },
    { value: '465_74', regionId: '74', text: 'Миасс' },
    { value: '432_61', regionId: '61', text: 'Миллерово' },
    { value: '2136_26', regionId: '26', text: 'Минеральные Воды' },
    { value: '262_24', regionId: '24', text: 'Минусинск' },
    { value: '118_14', regionId: '14', text: 'Мирный' },
    { value: '502_29', regionId: '29', text: 'Мирный' },
    { value: '2137_26', regionId: '26', text: 'Михайловск' },
    { value: '2085_68', regionId: '68', text: 'Мичуринск' },
    { value: '192_50', regionId: '50', text: 'Можайск' },
    { value: '485_18', regionId: '18', text: 'Можга' },
    { value: '316_77', regionId: '77', text: 'Москва' },
    { value: '388_50', regionId: '50', text: 'Московский' },
    { value: '17_51', regionId: '51', text: 'Мурманск' },
    { value: '339_33', regionId: '33', text: 'Муром' },
    { value: '420_57', regionId: '57', text: 'Мценск' },
    { value: '1983_42', regionId: '42', text: 'Мыски' },
    { value: '174_50', regionId: '50', text: 'Мытищи' },
    { value: '2207_16', regionId: '16', text: 'н.п.Осиново' },
    { value: '2046_16', regionId: '16', text: 'Набережные Челны' },
    { value: '324_76', regionId: '76', text: 'Нагорный' },
    { value: '96_89', regionId: '89', text: 'Надым' },
    { value: '263_24', regionId: '24', text: 'Назарово' },
    { value: '91_6', regionId: '6', text: 'Назрань' },
    { value: '32_7', regionId: '7', text: 'Нальчик' },
    { value: '331_30', regionId: '30', text: 'Нариманов' },
    { value: '175_50', regionId: '50', text: 'Наро-Фоминск' },
    { value: '297_83', regionId: '83', text: 'Нарьян-Мар' },
    { value: '120_25', regionId: '25', text: 'Находка' },
    { value: '2138_26', regionId: '26', text: 'Невинномысск' },
    { value: '121_14', regionId: '14', text: 'Нерюнгри' },
    { value: '170_2', regionId: '2', text: 'Нефтекамск' },
    { value: '292_86', regionId: '86', text: 'Нефтеюганск' },
    { value: '97_86', regionId: '86', text: 'Нижневартовск' },
    { value: '122_16', regionId: '16', text: 'Нижнекамск' },
    { value: '45_52', regionId: '52', text: 'Нижний Новгород' },
    { value: '464_11', regionId: '11', text: 'Нижний Одес' },
    { value: '162_66', regionId: '66', text: 'Нижний Тагил' },
    { value: '447_61', regionId: '61', text: 'Николаевка' },
    { value: '271_58', regionId: '58', text: 'Никольск' },
    { value: '1901_47', regionId: '47', text: 'Никольское' },
    { value: '2246_1', regionId: '1', text: 'Новая Адыгея' },
    { value: '470_22', regionId: '22', text: 'Новоалтайск' },
    { value: '1966_36', regionId: '36', text: 'Нововоронеж' },
    { value: '242_29', regionId: '29', text: 'Новодвинск' },
    { value: '2066_32', regionId: '32', text: 'Новозыбков' },
    { value: '301_23', regionId: '23', text: 'Новокубанск' },
    { value: '123_42', regionId: '42', text: 'Новокузнецк' },
    { value: '274_63', regionId: '63', text: 'Новокуйбышевск' },
    { value: '209_71', regionId: '71', text: 'Новомосковск' },
    { value: '477_23', regionId: '23', text: 'Новомышастовская ст.' },
    { value: '124_23', regionId: '23', text: 'Новороссийск' },
    { value: '68_54', regionId: '54', text: 'Новосибирск' },
    { value: '1967_36', regionId: '36', text: 'Новоусманский' },
    { value: '133_21', regionId: '21', text: 'Новочебоксарск' },
    { value: '216_61', regionId: '61', text: 'Новочеркасск' },
    { value: '2161_89', regionId: '89', text: 'Новый Уренгой' },
    { value: '290_50', regionId: '50', text: 'Ногинск' },
    { value: '484_24', regionId: '24', text: 'Норильск' },
    { value: '125_16', regionId: '16', text: 'Нурлат' },
    { value: '422_59', regionId: '59', text: 'Нытва' },
    { value: '1940_86', regionId: '86', text: 'Нягань' },
    { value: '126_40', regionId: '40', text: 'Обнинск' },
    { value: '2016_54', regionId: '54', text: 'Обь' },
    { value: '26_50', regionId: '50', text: 'Одинцово' },
    { value: '401_50', regionId: '50', text: 'Одинцово-10' },
    { value: '281_74', regionId: '74', text: 'Озерск' },
    { value: '396_50', regionId: '50', text: 'Озеры' },
    { value: '428_2', regionId: '2', text: 'Октябрьский' },
    { value: '69_55', regionId: '55', text: 'Омск' },
    { value: '27_57', regionId: '57', text: 'Орел' },
    { value: '46_56', regionId: '56', text: 'Оренбург' },
    { value: '320_50', regionId: '50', text: 'Орехово-Зуево' },
    { value: '283_56', regionId: '56', text: 'Орск' },
    { value: '304_59', regionId: '59', text: 'Оса' },
    { value: '326_69', regionId: '69', text: 'Осташков' },
    { value: '389_50', regionId: '50', text: 'Островцы' },
    { value: '450_63', regionId: '63', text: 'Отрадный' },
    { value: '423_59', regionId: '59', text: 'Очер' },
    { value: '2174_35', regionId: '35', text: 'п Кадуй' },
    { value: '1926_47', regionId: '47', text: 'п. Бугры' },
    { value: '2170_33', regionId: '33', text: 'п. Вольгинский' },
    { value: '2380_50', regionId: '50', text: 'п. Мебельной фабрики' },
    { value: '2277_47', regionId: '47', text: 'п. Новогорелово' },
    { value: '2280_47', regionId: '47', text: 'п. Пудость' },
    { value: '2168_31', regionId: '31', text: 'п. Северный' },
    { value: '2359_50', regionId: '50', text: 'п. совхоза им. Ленина' },
    { value: '2164_28', regionId: '28', text: 'п. Тепличный' },
    { value: '1867_50', regionId: '50', text: 'п.Андреевка' },
    { value: '1918_47', regionId: '47', text: 'п.Аннино' },
    { value: '1859_50', regionId: '50', text: 'п.Архангельское' },
    { value: '2129_38', regionId: '38', text: 'п.Березовый' },
    { value: '1817_50', regionId: '50', text: 'п.Биокомбинат' },
    { value: '2369_50', regionId: '50', text: 'п.Биорки' },
    { value: '2071_33', regionId: '33', text: 'п.Боголюбово' },
    { value: '1880_50', regionId: '50', text: 'п.Большевик' },
    { value: '2183_39', regionId: '39', text: 'п.Большое Исаково' },
    { value: '1908_47', regionId: '47', text: 'п.Бугры' },
    { value: '2247_62', regionId: '62', text: 'п.Варские' },
    { value: '1999_39', regionId: '39', text: 'п.Васильково' },
    { value: '2198_61', regionId: '61', text: 'п.Верхнетемерницкий' },
    { value: '1861_50', regionId: '50', text: 'п.Володарского' },
    { value: '2205_53', regionId: '53', text: 'п.Волховец' },
    { value: '1875_50', regionId: '50', text: 'п.Горки-10' },
    { value: '2232_76', regionId: '76', text: 'п.Горушка' },
    { value: '1874_50', regionId: '50', text: 'п.Демихово' },
    { value: '2374_50', regionId: '50', text: 'п.ДО Суханово' },
    { value: '2058_31', regionId: '31', text: 'п.Дубовое' },
    { value: '2028_24', regionId: '24', text: 'п.Емельяново' },
    { value: '2190_52', regionId: '52', text: 'п.Ждановский' },
    { value: '2333_50', regionId: '50', text: 'п.Жилино-1' },
    { value: '2234_74', regionId: '74', text: 'п.Западный' },
    { value: '2140_70', regionId: '70', text: 'п.Зональная станция' },
    { value: '1869_50', regionId: '50', text: 'п.Измайлово' },
    { value: '2181_38', regionId: '38', text: 'п.Изумрудный' },
    { value: '2057_61', regionId: '61', text: 'п.Каменоломни' },
    { value: '2006_44', regionId: '44', text: 'п.Караваево' },
    { value: '1985_42', regionId: '42', text: 'п.Кедровка' },
    { value: '1959_66', regionId: '66', text: 'п.Кирпичный' },
    { value: '2011_54', regionId: '54', text: 'п.Кольцово' },
    { value: '2072_33', regionId: '33', text: 'п.Коммунар' },
    { value: '2214_70', regionId: '70', text: 'п.Копылово' },
    { value: '2120_74', regionId: '74', text: 'п.Красное Поле' },
    { value: '2007_44', regionId: '44', text: 'п.Красное-на-Волге' },
    { value: '2278_47', regionId: '47', text: 'п.Красносельское' },
    { value: '2233_76', regionId: '76', text: 'п.Красный бор' },
    { value: '2105_35', regionId: '35', text: 'п.Кувшиново' },
    { value: '1858_50', regionId: '50', text: 'п.Купавна' },
    { value: '2096_56', regionId: '56', text: 'п.Ленина' },
    { value: '2087_71', regionId: '71', text: 'п.Ленинский' },
    { value: '1866_50', regionId: '50', text: 'п.Лесной' },
    { value: '2350_50', regionId: '50', text: 'п.Литвиново' },
    { value: '2199_54', regionId: '54', text: 'п.Ложок' },
    { value: '2176_35', regionId: '35', text: 'п.Майский' },
    { value: '2186_39', regionId: '39', text: 'п.Малое Лесное' },
    { value: '1865_50', regionId: '50', text: 'п.Менделеево' },
    { value: '2217_42', regionId: '42', text: 'п.Металлплощадка' },
    { value: '2329_50', regionId: '50', text: 'п.Мещерино' },
    { value: '2040_2', regionId: '2', text: 'п.Михайловка' },
    { value: '2297_50', regionId: '50', text: 'п.Михайловский' },
    { value: '2252_71', regionId: '71', text: 'п.Молодежный' },
    { value: '1922_47', regionId: '47', text: 'п.Мурино' },
    { value: '2208_16', regionId: '16', text: 'п.Набережные Моркваши' },
    { value: '2035_52', regionId: '52', text: 'п.Новинки' },
    { value: '1921_47', regionId: '47', text: 'п.Ново-Девяткино' },
    { value: '1900_47', regionId: '47', text: 'п.Новоселье' },
    { value: '1915_47', regionId: '47', text: 'п.Новый Свет' },
    { value: '2114_29', regionId: '29', text: 'п.Октябрьский' },
    { value: '2202_54', regionId: '54', text: 'п.Октябрьский' },
    { value: '2033_52', regionId: '52', text: 'п.Октябрьский' },
    { value: '2317_50', regionId: '50', text: 'п.ОПХ Ермолино' },
    { value: '1968_36', regionId: '36', text: 'п.Отрадное' },
    { value: '2295_50', regionId: '50', text: 'п.Отрадное' },
    { value: '2250_71', regionId: '71', text: 'п.Петровский' },
    { value: '1815_50', regionId: '50', text: 'п.Пирогово' },
    { value: '2067_32', regionId: '32', text: 'п.Погар' },
    { value: '1878_50', regionId: '50', text: 'п.Правдинский' },
    { value: '2097_56', regionId: '56', text: 'п.Пригородный' },
    { value: '2162_89', regionId: '89', text: 'п.Пурпе' },
    { value: '2068_32', regionId: '32', text: 'п.Путевка' },
    { value: '2253_71', regionId: '71', text: 'п.Рассвет' },
    { value: '1906_47', regionId: '47', text: 'п.Романовка' },
    { value: '2235_74', regionId: '74', text: 'п.Рощино' },
    { value: '2275_47', regionId: '47', text: 'п.Рощино' },
    { value: '2264_12', regionId: '12', text: 'п.Руэм' },
    { value: '2121_74', regionId: '74', text: 'п.Саргазы' },
    { value: '2371_50', regionId: '50', text: 'п.Селятино' },
    { value: '1964_36', regionId: '36', text: 'п.Сомово' },
    { value: '2290_47', regionId: '47', text: 'п.Сосново' },
    { value: '2283_47', regionId: '47', text: 'п.Тайцы' },
    { value: '1912_47', regionId: '47', text: 'п.Тельмана' },
    { value: '2379_50', regionId: '50', text: 'п.Томилино' },
    { value: '1917_47', regionId: '47', text: 'п.Усть-Луга' },
    { value: '2185_39', regionId: '39', text: 'п.Холмогоровка' },
    { value: '2175_35', regionId: '35', text: 'п.Шексна' },
    { value: '2257_18', regionId: '18', text: 'п.Шунды ' },
    { value: '1931_47', regionId: '47', text: 'п.Шушары' },
    { value: '1919_47', regionId: '47', text: 'п.Щеглово' },
    { value: '2360_50', regionId: '50', text: 'п.Электроизолятор' },
    { value: '2200_54', regionId: '54', text: 'п.Элитный' },
    { value: '1979_23', regionId: '23', text: 'п.Южный' },
    { value: '2156_13', regionId: '13', text: 'п.Ялга' },
    { value: '2326_50', regionId: '50', text: 'п/о Красногорск-4' },
    { value: '2352_50', regionId: '50', text: 'Павло-Слободское с/п' },
    { value: '244_52', regionId: '52', text: 'Павлово' },
    { value: '1936_78', regionId: '78', text: 'Павловск' },
    { value: '478_23', regionId: '23', text: 'Павловская ст.' },
    { value: '369_50', regionId: '50', text: 'Павловский Посад' },
    { value: '1988_42', regionId: '42', text: 'пгт. Промышленная' },
    { value: '2047_16', regionId: '16', text: 'пгт.Васильево' },
    { value: '1872_50', regionId: '50', text: 'пгт.Деденево' },
    { value: '1870_50', regionId: '50', text: 'пгт.Красково' },
    { value: '2012_54', regionId: '54', text: 'пгт.Краснообск' },
    { value: '1963_40', regionId: '40', text: 'пгт.Кременки' },
    { value: '2131_21', regionId: '21', text: 'пгт.Кугеси' },
    { value: '1868_50', regionId: '50', text: 'пгт.Лесной Городок' },
    { value: '2152_12', regionId: '12', text: 'пгт.Медведево' },
    { value: '1881_50', regionId: '50', text: 'пгт.Некрасовский' },
    { value: '2030_43', regionId: '43', text: 'пгт.Нижнеивкино' },
    { value: '2003_63', regionId: '63', text: 'пгт.Новосемейкино' },
    { value: '2153_12', regionId: '12', text: 'пгт.Оршанка' },
    { value: '1863_50', regionId: '50', text: 'пгт.Пироговский' },
    { value: '2059_31', regionId: '31', text: 'пгт.Разумное' },
    { value: '2154_13', regionId: '13', text: 'пгт.Ромоданово' },
    { value: '2349_50', regionId: '50', text: 'пгт.Сверловский' },
    { value: '1871_50', regionId: '50', text: 'пгт.Серебряные Пруды' },
    { value: '2004_63', regionId: '63', text: 'пгт.Смышляевка' },
    { value: '1879_50', regionId: '50', text: 'пгт.Фряново' },
    { value: '2111_1', regionId: '1', text: 'пгт.Яблоновский' },
    { value: '2000_39', regionId: '39', text: 'пгт.Янтарный' },
    { value: '47_58', regionId: '58', text: 'Пенза' },
    { value: '163_66', regionId: '66', text: 'Первоуральск' },
    { value: '178_50', regionId: '50', text: 'Пересвет' },
    { value: '461_76', regionId: '76', text: 'Переславль-Залесский' },
    { value: '2021_59', regionId: '59', text: 'Пермский' },
    { value: '49_59', regionId: '59', text: 'Пермь' },
    { value: '392_50', regionId: '50', text: 'Пески' },
    { value: '444_61', regionId: '61', text: 'Песчанокопское' },
    { value: '1929_78', regionId: '78', text: 'Петергоф' },
    { value: '15_10', regionId: '10', text: 'Петрозаводск' },
    { value: '82_41', regionId: '41', text: 'Петропавловск-Камчатский' },
    { value: '357_45', regionId: '45', text: 'Петухово' },
    { value: '473_33', regionId: '33', text: 'Петушки' },
    { value: '308_11', regionId: '11', text: 'Печора' },
    { value: '1994_39', regionId: '39', text: 'Пионерский' },
    { value: '219_29', regionId: '29', text: 'Плесецк' },
    { value: '182_50', regionId: '50', text: 'Подольск' },
    { value: '313_72', regionId: '72', text: 'Покачи' },
    { value: '346_33', regionId: '33', text: 'Покров' },
    { value: '435_61', regionId: '61', text: 'Покровское' },
    { value: '305_59', regionId: '59', text: 'Полазна' },
    { value: '1995_39', regionId: '39', text: 'Полесск' },
    { value: '1986_42', regionId: '42', text: 'Полысаево' },
    { value: '1820_50', regionId: '50', text: 'пос. Коммунарка' },
    { value: '1823_50', regionId: '50', text: 'пос. Мосрентген' },
    { value: '2353_50', regionId: '50', text: 'пос.д/о «Бекасово»' },
    { value: '451_63', regionId: '63', text: 'Похвистнево' },
    { value: '127_47', regionId: '47', text: 'Приозерск' },
    { value: '255_42', regionId: '42', text: 'Прокопьевск' },
    { value: '442_61', regionId: '61', text: 'Пролетарск' },
    { value: '365_50', regionId: '50', text: 'Пролетарский' },
    { value: '98_60', regionId: '60', text: 'Псков' },
    { value: '1923_78', regionId: '78', text: 'Пушкин' },
    { value: '173_50', regionId: '50', text: 'Пушкино' },
    { value: '368_50', regionId: '50', text: 'Пущино' },
    { value: '1941_86', regionId: '86', text: 'Пыть-Ях' },
    { value: '252_26', regionId: '26', text: 'Пятигорск' },
    { value: '1957_66', regionId: '66', text: 'р.п. Белоярский' },
    { value: '1856_50', regionId: '50', text: 'р.п. Нахабино' },
    { value: '1850_50', regionId: '50', text: 'р.п. Октябрьский' },
    { value: '2385_50', regionId: '50', text: 'р.п.Андреевка' },
    { value: '2316_50', regionId: '50', text: 'р.п.Большие Вяземы' },
    { value: '2173_34', regionId: '34', text: 'р.п.Городище' },
    { value: '1835_50', regionId: '50', text: 'р.п.Заречье' },
    { value: '2143_73', regionId: '73', text: 'р.п.Ишеевка' },
    { value: '2265_13', regionId: '13', text: 'р.п.Луховка' },
    { value: '2180_38', regionId: '38', text: 'р.п.Маркова' },
    { value: '2327_50', regionId: '50', text: 'р.п.Новоивановское' },
    { value: '2219_2', regionId: '2', text: 'р.п.Чишмы' },
    { value: '2074_33', regionId: '33', text: 'Радужный' },
    { value: '387_50', regionId: '50', text: 'Развилка' },
    { value: '207_50', regionId: '50', text: 'Раменское' },
    { value: '1955_66', regionId: '66', text: 'Ревда' },
    { value: '327_69', regionId: '69', text: 'Редкино' },
    { value: '198_50', regionId: '50', text: 'Реутов' },
    { value: '328_69', regionId: '69', text: 'Ржев' },
    { value: '437_61', regionId: '61', text: 'Родионово-Несветайская' },
    { value: '2294_47', regionId: '47', text: 'Романовское с.п.' },
    { value: '462_76', regionId: '76', text: 'Ростов' },
    { value: '36_61', regionId: '61', text: 'Ростов-на-Дону' },
    { value: '2201_54', regionId: '54', text: 'рп.Колывань' },
    { value: '131_22', regionId: '22', text: 'Рубцовск' },
    { value: '398_50', regionId: '50', text: 'Руза' },
    { value: '2155_13', regionId: '13', text: 'Рузаевка' },
    { value: '460_76', regionId: '76', text: 'Рыбинск' },
    { value: '2080_62', regionId: '62', text: 'Рыбное' },
    { value: '359_46', regionId: '46', text: 'Рыльск' },
    { value: '28_62', regionId: '62', text: 'Рязань' },
    { value: '2178_36', regionId: '36', text: 'с. Березово' },
    { value: '2069_32', regionId: '32', text: 'с. Глинищево' },
    { value: '2171_33', regionId: '33', text: 'с. Дмитриевская Слобода' },
    { value: '2022_59', regionId: '59', text: 'с. Култаево' },
    { value: '2049_16', regionId: '16', text: 'с. Новое Шигалеево' },
    { value: '1958_66', regionId: '66', text: 'с. Патруши' },
    { value: '2167_28', regionId: '28', text: 'с. Чигири' },
    { value: '1969_36', regionId: '36', text: 'с. Ямное' },
    { value: '2132_21', regionId: '21', text: 'с.Аликово' },
    { value: '2376_50', regionId: '50', text: 'с.Анискино' },
    { value: '2262_25', regionId: '25', text: 'с.Баневурово' },
    { value: '2133_21', regionId: '21', text: 'с.Батырево' },
    { value: '2053_58', regionId: '58', text: 'с.Бессоновка' },
    { value: '2141_70', regionId: '70', text: 'с.Богашево' },
    { value: '2054_58', regionId: '58', text: 'с.Богословка' },
    { value: '2086_68', regionId: '68', text: 'с.Бокино' },
    { value: '2375_50', regionId: '50', text: 'с.Братовщина' },
    { value: '2220_2', regionId: '2', text: 'с.Буздяк' },
    { value: '2221_2', regionId: '2', text: 'с.Булгаково' },
    { value: '2314_50', regionId: '50', text: 'с.Верзилово' },
    { value: '2015_54', regionId: '54', text: 'с.Верх-Тула' },
    { value: '2115_11', regionId: '11', text: 'с.Выльгорт' },
    { value: '2248_62', regionId: '62', text: 'с.Дядьково' },
    { value: '2222_2', regionId: '2', text: 'с.Ермекеево' },
    { value: '2126_18', regionId: '18', text: 'с.Завьялово' },
    { value: '2055_58', regionId: '58', text: 'с.Засечное' },
    { value: '2098_56', regionId: '56', text: 'с.Ивановка' },
    { value: '2223_2', regionId: '2', text: 'с.Иглино' },
    { value: '2018_54', regionId: '54', text: 'с.Каменка' },
    { value: '2041_2', regionId: '2', text: 'с.Кармаскалы' },
    { value: '2042_2', regionId: '2', text: 'с.Красноусольский' },
    { value: '2203_54', regionId: '54', text: 'с.Криводановка' },
    { value: '2024_59', regionId: '59', text: 'с.Култаево' },
    { value: '2224_2', regionId: '2', text: 'с.Кушнаренково' },
    { value: '2025_59', regionId: '59', text: 'с.Лобаново' },
    { value: '2263_4', regionId: '4', text: 'с.Майма' },
    { value: '2255_27', regionId: '27', text: 'с.Мирное' },
    { value: '2099_56', regionId: '56', text: 'с.Михайловка' },
    { value: '2330_50', regionId: '50', text: 'с.Молоково' },
    { value: '2109_35', regionId: '35', text: 'с.Молочное' },
    { value: '2100_56', regionId: '56', text: 'с.Нежинка' },
    { value: '2328_50', regionId: '50', text: 'с.Немчиновка' },
    { value: '1970_36', regionId: '36', text: 'с.Новая Усмань' },
    { value: '2383_50', regionId: '50', text: 'с.Озерецкое' },
    { value: '2258_18', regionId: '18', text: 'с.Октябрьский' },
    { value: '2050_16', regionId: '16', text: 'с.Осиново' },
    { value: '1824_50', regionId: '50', text: 'с.п. Воскресенское' },
    { value: '1847_50', regionId: '50', text: 'с.п. Молоковское' },
    { value: '1851_50', regionId: '50', text: 'с.п. Сосенское' },
    { value: '1842_50', regionId: '50', text: 'с.п. Стрелковское' },
    { value: '1830_50', regionId: '50', text: 'с.п.Булатниковское' },
    { value: '2215_70', regionId: '70', text: 'с.п.Заречное' },
    { value: '2331_50', regionId: '50', text: 'с.п.Обушковское' },
    { value: '2325_50', regionId: '50', text: 'с.Павловская Слобода' },
    { value: '2259_18', regionId: '18', text: 'с.Первомайский' },
    { value: '2364_50', regionId: '50', text: 'с.Перхушково' },
    { value: '2051_16', regionId: '16', text: 'с.Пестрецы' },
    { value: '1873_50', regionId: '50', text: 'с.Петрово-Дальнее' },
    { value: '2389_38', regionId: '38', text: 'с.Пивовариха' },
    { value: '2101_56', regionId: '56', text: 'с.Подгородняя Покровка' },
    { value: '2195_63', regionId: '63', text: 'с.Подстепки' },
    { value: '1877_50', regionId: '50', text: 'с.Покров' },
    { value: '2148_7', regionId: '7', text: 'с.Прималкинское' },
    { value: '2192_58', regionId: '58', text: 'с.Рамзай' },
    { value: '2338_50', regionId: '50', text: 'с.Рождествено' },
    { value: '2102_56', regionId: '56', text: 'с.Степановка' },
    { value: '2043_2', regionId: '2', text: 'с.Стерлибашево' },
    { value: '2226_2', regionId: '2', text: 'с.Суук-Чишма' },
    { value: '2117_25', regionId: '25', text: 'с.Тавричанка' },
    { value: '2118_27', regionId: '27', text: 'с.Тополево' },
    { value: '2113_8', regionId: '8', text: 'с.Троицкое' },
    { value: '2242_55', regionId: '55', text: 'с.Троицкое' },
    { value: '2052_16', regionId: '16', text: 'с.Усады' },
    { value: '1862_50', regionId: '50', text: 'с.Успенское' },
    { value: '2026_59', regionId: '59', text: 'с.Усть-Качка' },
    { value: '2227_2', regionId: '2', text: 'с.Федоровка' },
    { value: '2023_59', regionId: '59', text: 'с.Фролы' },
    { value: '2228_2', regionId: '2', text: 'с.Языково' },
    { value: '1882_50', regionId: '50', text: 'с/з Ленина Дом Быта' },
    { value: '2387_50', regionId: '50', text: 'с/п Ильинское' },
    { value: '2271_47', regionId: '47', text: 'САЗОТ Ручьи' },
    { value: '168_2', regionId: '2', text: 'Салават' },
    { value: '166_89', regionId: '89', text: 'Салехард' },
    { value: '433_61', regionId: '61', text: 'Сальск' },
    { value: '54_63', regionId: '63', text: 'Самара' },
    { value: '446_61', regionId: '61', text: 'Самарское' },
    { value: '13_78', regionId: '78', text: 'Санкт-Петербург' },
    { value: '52_13', regionId: '13', text: 'Саранск' },
    { value: '454_18', regionId: '18', text: 'Сарапул' },
    { value: '55_64', regionId: '64', text: 'Саратов' },
    { value: '416_52', regionId: '52', text: 'Саров' },
    { value: '278_74', regionId: '74', text: 'Сатка' },
    { value: '184_38', regionId: '38', text: 'Саянск' },
    { value: '1996_39', regionId: '39', text: 'Светлогорск' },
    { value: '1997_39', regionId: '39', text: 'Светлый' },
    { value: '85_29', regionId: '29', text: 'Северодвинск' },
    { value: '2142_70', regionId: '70', text: 'Северск' },
    { value: '1971_36', regionId: '36', text: 'Семилуки' },
    { value: '132_50', regionId: '50', text: 'Сергиев Посад' },
    { value: '267_58', regionId: '58', text: 'Сердобск' },
    { value: '165_66', regionId: '66', text: 'Серов' },
    { value: '193_50', regionId: '50', text: 'Серпухов' },
    { value: '1902_47', regionId: '47', text: 'Сертолово' },
    { value: '1930_78', regionId: '78', text: 'Сестрорецк' },
    { value: '221_2', regionId: '2', text: 'Сибай' },
    { value: '2194_43', regionId: '43', text: 'сл.Шулаи' },
    { value: '1975_23', regionId: '23', text: 'Славянск-на-Кубани' },
    { value: '2031_43', regionId: '43', text: 'Слободской' },
    { value: '88_67', regionId: '67', text: 'Смоленск' },
    { value: '185_74', regionId: '74', text: 'Снежинск' },
    { value: '414_51', regionId: '51', text: 'Снежногорск' },
    { value: '343_33', regionId: '33', text: 'Собинка' },
    { value: '1998_39', regionId: '39', text: 'Советск' },
    { value: '474_27', regionId: '27', text: 'Советская Гавань' },
    { value: '456_86', regionId: '86', text: 'Советский' },
    { value: '424_59', regionId: '59', text: 'Соликамск' },
    { value: '226_50', regionId: '50', text: 'Солнечногорск' },
    { value: '128_10', regionId: '10', text: 'Сортавала' },
    { value: '264_24', regionId: '24', text: 'Сосновоборск' },
    { value: '129_47', regionId: '47', text: 'Сосновый Бор' },
    { value: '307_11', regionId: '11', text: 'Сосногорск' },
    { value: '1818_50', regionId: '50', text: 'Софрино' },
    { value: '186_23', regionId: '23', text: 'Сочи' },
    { value: '2197_63', regionId: '63', text: 'сп.Выселки' },
    { value: '2196_63', regionId: '63', text: 'сп.Красный Яр' },
    { value: '2241_66', regionId: '66', text: 'Среднеуральск' },
    { value: '2139_26', regionId: '26', text: 'ст-ца Ессентукская' },
    { value: '234_33', regionId: '33', text: 'Ставрово пос.' },
    { value: '39_26', regionId: '26', text: 'Ставрополь' },
    { value: '1827_50', regionId: '50', text: 'Старая Купавна' },
    { value: '2070_32', regionId: '32', text: 'Стародуб' },
    { value: '228_31', regionId: '31', text: 'Старый Оскол' },
    { value: '2044_2', regionId: '2', text: 'Стерлитамак' },
    { value: '2061_31', regionId: '31', text: 'Строитель' },
    { value: '2075_33', regionId: '33', text: 'Струнино' },
    { value: '363_50', regionId: '50', text: 'Ступино' },
    { value: '235_33', regionId: '33', text: 'Судогда' },
    { value: '2076_33', regionId: '33', text: 'Суздаль' },
    { value: '1884_86', regionId: '86', text: 'Сургут' },
    { value: '92_72', regionId: '72', text: 'Сургут' },
    { value: '296_63', regionId: '63', text: 'Сызрань' },
    { value: '16_11', regionId: '11', text: 'Сыктывкар' },
    { value: '1961_66', regionId: '66', text: 'Сысерть' },
    { value: '172_61', regionId: '61', text: 'Таганрог' },
    { value: '179_50', regionId: '50', text: 'Талдом' },
    { value: '31_68', regionId: '68', text: 'Тамбов' },
    { value: '199_55', regionId: '55', text: 'Тара' },
    { value: '441_61', regionId: '61', text: 'Тарасовский' },
    { value: '2163_89', regionId: '89', text: 'Тарко-Сале' },
    { value: '2112_1', regionId: '1', text: 'Тахтамукай' },
    { value: '350_42', regionId: '42', text: 'Таштагол' },
    { value: '29_69', regionId: '69', text: 'Тверь' },
    { value: '236_37', regionId: '37', text: 'Тейково' },
    { value: '1976_23', regionId: '23', text: 'Темрюк' },
    { value: '2149_7', regionId: '7', text: 'Терек' },
    { value: '302_23', regionId: '23', text: 'Тимашевск' },
    { value: '130_47', regionId: '47', text: 'Тихвин' },
    { value: '1977_23', regionId: '23', text: 'Тихорецк' },
    { value: '2125_72', regionId: '72', text: 'Тобольск' },
    { value: '90_63', regionId: '63', text: 'Тольятти' },
    { value: '74_70', regionId: '70', text: 'Томск' },
    { value: '1987_42', regionId: '42', text: 'Топки' },
    { value: '1989_69', regionId: '69', text: 'Торжок' },
    { value: '329_69', regionId: '69', text: 'Торопец' },
    { value: '318_47', regionId: '47', text: 'Тосно' },
    { value: '325_35', regionId: '35', text: 'Тотьма' },
    { value: '276_74', regionId: '74', text: 'Трехгорный' },
    { value: '2122_74', regionId: '74', text: 'Троицк' },
    { value: '176_50', regionId: '50', text: 'Троицк' },
    { value: '2344_77', regionId: '77', text: 'Троицк' },
    { value: '171_2', regionId: '2', text: 'Туймазы' },
    { value: '30_71', regionId: '71', text: 'Тула' },
    { value: '2090_76', regionId: '76', text: 'Тутаев' },
    { value: '194_50', regionId: '50', text: 'Тучково' },
    { value: '62_72', regionId: '72', text: 'Тюмень' },
    { value: '353_42', regionId: '42', text: 'Тяжинский' },
    { value: '330_69', regionId: '69', text: 'Удомля' },
    { value: '2088_71', regionId: '71', text: 'Узловая' },
    { value: '71_3', regionId: '3', text: 'Улан-Удэ' },
    { value: '58_73', regionId: '73', text: 'Ульяновск' },
    { value: '312_72', regionId: '72', text: 'Урай' },
    { value: '1942_86', regionId: '86', text: 'Урай' },
    { value: '2268_20', regionId: '20', text: 'Урус-Мартан' },
    { value: '167_11', regionId: '11', text: 'Усинск' },
    { value: '2212_59', regionId: '59', text: 'Усолье' },
    { value: '114_25', regionId: '25', text: 'Уссурийск' },
    { value: '2182_38', regionId: '38', text: 'Усть-Кут' },
    { value: '50_2', regionId: '2', text: 'Уфа' },
    { value: '306_11', regionId: '11', text: 'Ухта' },
    { value: '287_2', regionId: '2', text: 'Учалы' },
    { value: '448_61', regionId: '61', text: 'Фёдоровка' },
    { value: '1857_50', regionId: '50', text: 'Филимонковское' },
    { value: '298_34', regionId: '34', text: 'Фролово' },
    { value: '2078_37', regionId: '37', text: 'Фурманов' },
    { value: '81_27', regionId: '27', text: 'Хабаровск' },
    { value: '83_86', regionId: '86', text: 'Ханты-Мансийск' },
    { value: '2145_5', regionId: '5', text: 'Хасавюрт' },
    { value: '220_50', regionId: '50', text: 'Химки' },
    { value: '411_50', regionId: '50', text: 'Хотьково' },
    { value: '1973_36', regionId: '36', text: 'Хохольский' },
    { value: '445_61', regionId: '61', text: 'Целина' },
    { value: '2236_21', regionId: '21', text: 'Цивильск' },
    { value: '113_59', regionId: '59', text: 'Чайковский' },
    { value: '2395_63', regionId: '63', text: 'Чапаевск' },
    { value: '282_74', regionId: '74', text: 'Чебаркуль' },
    { value: '57_21', regionId: '21', text: 'Чебоксары' },
    { value: '2150_7', regionId: '7', text: 'Чегем' },
    { value: '61_74', regionId: '74', text: 'Челябинск' },
    { value: '426_4', regionId: '4', text: 'Чемал' },
    { value: '2106_35', regionId: '35', text: 'Череповец' },
    { value: '41_9', regionId: '9', text: 'Черкесск' },
    { value: '177_50', regionId: '50', text: 'Черноголовка' },
    { value: '431_19', regionId: '19', text: 'Черногорск' },
    { value: '303_59', regionId: '59', text: 'Чернушка' },
    { value: '224_50', regionId: '50', text: 'Чехов' },
    { value: '112_16', regionId: '16', text: 'Чистополь' },
    { value: '295_75', regionId: '75', text: 'Чита' },
    { value: '376_50', regionId: '50', text: 'Чулковское' },
    { value: '146_59', regionId: '59', text: 'Чусовой' },
    { value: '356_45', regionId: '45', text: 'Шадринск' },
    { value: '265_24', regionId: '24', text: 'Шарыпово' },
    { value: '248_50', regionId: '50', text: 'Шатура' },
    { value: '217_61', regionId: '61', text: 'Шахты' },
    { value: '425_4', regionId: '4', text: 'Шебалино' },
    { value: '2127_38', regionId: '38', text: 'Шелехов' },
    { value: '2209_16', regionId: '16', text: 'Шигалевское с.п.' },
    { value: '2285_47', regionId: '47', text: 'Шлиссельбург' },
    { value: '458_21', regionId: '21', text: 'Шумерля' },
    { value: '358_45', regionId: '45', text: 'Шумиха' },
    { value: '355_24', regionId: '24', text: 'Шушенское' },
    { value: '237_37', regionId: '37', text: 'Шуя' },
    { value: '2089_71', regionId: '71', text: 'Щекино' },
    { value: '205_50', regionId: '50', text: 'Щелково' },
    { value: '372_50', regionId: '50', text: 'Щелково-3' },
    { value: '371_50', regionId: '50', text: 'Щелково-4' },
    { value: '1885_77', regionId: '77', text: 'Щербинка' },
    { value: '366_50', regionId: '50', text: 'Щербинка' },
    { value: '1822_50', regionId: '50', text: 'Электрогорск' },
    { value: '206_50', regionId: '50', text: 'Электросталь' },
    { value: '375_50', regionId: '50', text: 'Электроугли' },
    { value: '43_8', regionId: '8', text: 'Элиста' },
    { value: '111_64', regionId: '64', text: 'Энгельс' },
    { value: '408_50', regionId: '50', text: 'Юбилейный' },
    { value: '1943_86', regionId: '86', text: 'Югорск' },
    { value: '80_65', regionId: '65', text: 'Южно-Сахалинск' },
    { value: '275_74', regionId: '74', text: 'Южноуральск' },
    { value: '351_42', regionId: '42', text: 'Юрга' },
    { value: '149_59', regionId: '59', text: 'Яйва пгт' },
    { value: '79_14', regionId: '14', text: 'Якутск' },
    { value: '463_11', regionId: '11', text: 'Ярега' },
    { value: '89_76', regionId: '76', text: 'Ярославль' },
    { value: '412_50', regionId: '50', text: 'Яхрома' }];
